import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

// Api
import { fetchAgendaAiSlackChannels } from 'Shared/api/onboardingState';

// Types
import { IntegrationSources } from 'Shared/constants/IntegrationsList.constants';
import { Workspace } from 'Shared/types/Workspace.type';
import { SlackChannelType } from 'Shared/types/SlackChannel.type';

// Components
import { WpModal, WpModalHeader, WpModalBody, WpModalFooter } from 'Wpds/components/modal';
import { WpButton, WpButtonGroup } from 'Wpds/components/button';
import SlackWorkspaceSelect from 'Shared/components/SlackWorkspaceSelect/SlackWorkspaceSelect';
import IntegrationsWrapper from 'Dashboard/components/IntegrationsWrapper/IntegrationsWrapper';

// Styles
import './SelectSlackChannelsModal.scss';

type Props = {
  isOpen: boolean;
  toggleIsOpen: () => void;
  selectedChannels: string[];
  onSelectChannel: Function;
  oauthRedirectUrl?: string;
  note?: string;
};

const SelectSlackChannelsModal = ({
  isOpen,
  toggleIsOpen,
  selectedChannels = [],
  onSelectChannel,
  oauthRedirectUrl,
  note,
}: Props) => {
  const [availableChannels, setAvailableChannels] = useState(null);

  const selected: SlackChannelType[] =
    availableChannels && selectedChannels?.map(channel => availableChannels.find(ac => ac.id === channel));

  const slackAiDataSource: Workspace = useSelector(state =>
    state.data_sources.find(ds => ds.slug === 'slack-ai' && ds.connected === true)
  );

  const handleOnChange = (channels: SlackChannelType[]) => {
    onSelectChannel(channels);
  };

  useEffect(() => {
    if (slackAiDataSource)
      fetchAgendaAiSlackChannels().then(resposne => {
        setAvailableChannels(resposne.data);
      });
  }, []);

  const baseClassName = 'SelectSlackChannelsModal';

  return (
    <WpModal isOpen={isOpen} onToggle={toggleIsOpen} dismissOnBackdrop={false} size="sm">
      <WpModalHeader>Select channels</WpModalHeader>
      <WpModalBody>
        <div className={baseClassName}>
          {!slackAiDataSource ? (
            <>
              <p>Connect Slack to use UpdateAI</p>
              <IntegrationsWrapper filters={{ showOnly: [IntegrationSources.SLACK] }} redirectUrl={oauthRedirectUrl} />
            </>
          ) : (
            <>
              {!availableChannels ? (
                <>fetching available Slack channels</>
              ) : (
                <SlackWorkspaceSelect
                  options={availableChannels}
                  selected={selected}
                  onChange={handleOnChange}
                  label="Select the Slack channels"
                  helpText={note}
                />
              )}
            </>
          )}
        </div>
      </WpModalBody>
      <WpModalFooter>
        <WpButtonGroup>
          <WpButton variant={slackAiDataSource ? 'primary' : 'tertiary'} onClick={toggleIsOpen}>
            {slackAiDataSource ? 'Done' : 'Close'}
          </WpButton>
        </WpButtonGroup>
      </WpModalFooter>
    </WpModal>
  );
};

export default SelectSlackChannelsModal;
